import React from 'react';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { OrderBuilder } from '../components/OrderBuilder/OrderBuilder';
import { ProblemSection } from '../components/ProblemSection';
import { DoorsSection } from '../components/DoorsSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TrustSection } from '../components/TrustSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { UrgencySection } from '../components/UrgencySection';
import { DistributorSection } from '../components/DistributorSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCta } from '../components/FinalCta';
import { SiteFooter } from '../components/SiteFooter';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
export function Landing() {
  return <div className="min-h-screen w-full bg-white" data-id="element-323" data-mp="m7lg12w3ih8y">
      <SiteHeader data-id="element-324" data-mp="m83jajh6dvqd" />
      <main data-id="element-325" data-mp="m5hc4ky75i8o">
        <Hero data-id="element-326" data-mp="m58wilaovyts" />
        <OrderBuilder data-id="element-327" data-mp="29s92kf0fqyp" />
        <ProblemSection data-id="element-328" data-mp="2aa9zucmatcy" />
        <DoorsSection data-id="element-329" data-mp="2blejwdw0554" />
        <BenefitsSection data-id="element-330" data-mp="27ntv6bnv5j4" />
        <TestimonialsSection data-id="element-331" data-mp="3tglanpdpts3r" />
        <TrustSection data-id="element-332" data-mp="3tfjvp9tkwlgr" />
        <UrgencySection data-id="element-333" data-mp="3tf0drt3xhx2q" />
        <DistributorSection data-id="element-334" data-mp="3peq8kinynaox" />
        <FaqSection data-id="element-335" data-mp="3pdyc75mjh8xl" />
        <FinalCta data-id="element-336" data-mp="3pfj6qv8usrvg" />
      </main>
      <SiteFooter data-id="element-337" data-mp="3pguc2zhy67oo" />
      <FloatingWhatsApp data-id="element-338" data-mp="3kfwsqjl7b7ll" />
    </div>;
}